import axios from 'axios';
import { toast } from 'sonner';

export const API = (process.env.REACT_APP_BACKEND_URL || window.location.origin) + '/api/care';

export const care = axios.create({ baseURL: API });
care.interceptors.request.use((cfg) => {
  const t = localStorage.getItem('care_token');
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
care.interceptors.response.use((r) => r, (err) => {
  if (err.response?.status === 401 && !err.config.url.includes('/auth/')) {
    localStorage.removeItem('care_token');
    localStorage.removeItem('care_user');
    window.location.href = '/care/login';
  }
  return Promise.reject(err);
});

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || 'Something went wrong. Please try again.';
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map((x) => `${(x.loc || []).slice(-1)[0] || ''}: ${x.msg}`).join(' ');
  return String(d);
};

export const fail = (e) => toast.error(errMsg(e));

export const rm = (v) => `RM ${Number(v || 0).toLocaleString('en-MY', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const getUser = () => { try { return JSON.parse(localStorage.getItem('care_user') || 'null'); } catch { return null; } };

export const can = (...roles) => roles.includes(getUser()?.role);

export async function openFile(path, download = false, filename = 'document') {
  try {
    const r = await care.get(path, { responseType: 'blob' });
    const url = URL.createObjectURL(r.data);
    if (download) {
      const a = document.createElement('a');
      a.href = url; a.download = filename; a.click();
    } else {
      window.open(url, '_blank');
    }
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (e) {
    toast.error('Could not open the file. Please try again.');
  }
}
